import React, { PureComponent } from "react";
import * as styles from "./style.css";
import UQFormsTextField from "../text-field";
import { createClassNames } from "../../../../infrastructure/helpers";
import Icon from "../../../icons/Icon";
import PropTypes from 'prop-types';

export default class UQFormsPasswordField extends PureComponent {
  static defaultProps = {
    eyeVisible: true
  };

  static propTypes = {
    eyeVisible: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      secureTextEntry: props.secureTextEntry || true
    };
  }

  onEyePressed = () => {
    this.setState({ secureTextEntry: !this.state.secureTextEntry });
  };

  render() {
    const { eyeVisible, secureTextEntry, ...otherProps } = this.props;
    const containerStyles = createClassNames([styles.container, this.props.containerClass]);
    const type = this.state.secureTextEntry ? 'password' : 'text';
    return (
      <div className={containerStyles}>
        <UQFormsTextField
          { ...otherProps }
          type={type}/>
        {
          this.props.eyeVisible && (
            <button type="button"
                    className={styles.eyeWrap}
                    onClick={this.onEyePressed}>
              <Icon name="Eye" width="24px" height="18px"/>
            </button>
          )
        } 
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/uq-forms/components/password-field/index.jsx